<template>
  <div :class="{ 'order-creator': true, 'is-loading': !allDataLoaded }">
    <h4 class="mb-3 pb-3 d-flex border-bottom">
      <span>Zamówienie</span>

      <d-button
        theme="success"
        class="ml-auto"
        :disabled="!allDataLoaded || !canEdit"
        @click.prevent="$bus.$emit('order-product-popup-show')">
        <div
          v-if="!allDataLoaded"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        Dodaj produkt
      </d-button>
    </h4>

    <d-alert
      v-if="data.products.length === 0"
      show
      theme="warning"
      class="text-center">
      Dodaj produkty do zamówienia klikając przycisk "Dodaj produkt"
    </d-alert>

    <d-alert
      v-if="invalidDatesInCreator"
      theme="danger"
      show
      class="text-center">
      <strong>Uwaga!</strong> Niektóre daty w procesach wykraczają poza przyjęty czas wysyłki zamówienia zamówienia.
    </d-alert>

    <order-creator-product
      v-for="(product, index) of data.products"
      :key="'product-' + index"
      :ref="'order-product-' + index"
      :productData="product"
      :productIndex="index"
      :products="products"
      :procedures="procedures"
      :colors="colors"
      :seams="seams"
      :strands="strands"
      :polars="polars"
      :sizes="sizes"
      :workers="workers"
      :canEdit="canEdit" />

    <select-date-popup />
  </div>
</template>

<script>
import OrderCreatorProduct from './OrderCreatorProduct.vue';
import SelectDatePopup from './../../popups/SelectDatePopup.vue';
import Vue from 'vue';

export default {
  name: 'order-creator',
  props: [
    'products',
    'procedures',
    'colors',
    'seams',
    'strands',
    'polars',
    'sizes',
    'realizationDate',
    'workers',
    'canEdit'
  ],
  components: {
    'order-creator-product': OrderCreatorProduct,
    'select-date-popup': SelectDatePopup
  },
  computed: {
    invalidDatesInCreator () {
      let datesToCheck = [];

      if (!this.realizationDate) {
        return false;
      }

      for (let i = 0; i < this.data.products.length; i++) {
        let product = this.data.products[i];
        datesToCheck.push(product.procedure_start_date);

        for (let j = 0; j < product.processes.length; j++) {
          let process = product.processes[j];
          datesToCheck.push(process.start_at);

          for (let k = 0; k < process.items.length; k++) {
            let item = process.items[k];
            datesToCheck.push(item.end_at);
          }
        }
      }

      datesToCheck = datesToCheck.filter(date => !!date);
      datesToCheck = datesToCheck.filter(date => {
        date = date.split('-').map(n => parseInt(n, 10));
        let dateToCompare = new Date(date[0], date[1] - 1, date[2], 0, 0, 0, 0);
        return dateToCompare > this.realizationDate;
      });

      return !!datesToCheck.length;
    }
  },
  watch: {
    'data.products': {
      handler() {
        this.$bus.$emit('order-creator-products-updated');
      },
      deep: true
    }
  },
  data () {
    return {
      allDataLoaded: false,
      data: {
        products: []
      }
    }
  },
  mounted () {
    this.$bus.$on('order-product-add', this.addProduct);
    this.$bus.$on('order-form-remove-product', this.removeProduct);
    this.$bus.$on('order-form-all-data-loaded-status', this.setAllDataLoaded);
  },
  methods: {
    getProducts () {
      let productsForSubmit = JSON.parse(JSON.stringify(this.data.products));

      productsForSubmit = productsForSubmit.map(product => {
        product.processes = product.processes.map(process => {
          process.items = process.items.map(item => {
            item.days = parseInt(item.days, 10);
            item.quantity = parseInt(item.quantity, 10);
            item.quantity_done = parseInt(item.quantity_done, 10);

            return item;
          });

          return process;
        });

        return product;
      });

      return productsForSubmit;
    },
    addProduct (productData) {
      let foundedProduct = this.products.filter(product => product.id === productData.product_id);
      let hasOneProcedureAvailable = false;

      if (foundedProduct[0] && foundedProduct[0].procedures.length === 1) {
        hasOneProcedureAvailable = true;
      }

      let defaultStrandID = productData.default_strand;

      if (productData.default_strand === null && foundedProduct[0] && foundedProduct[0].strand_id) {
        defaultStrandID = foundedProduct[0].strand_id;
      }

      this.data.products.push({
        id: null,
        product_id: productData.product_id,
        quantity: productData.quantity,
        size_id: productData.size,
        color_id: productData.color_id,
        polar_id: productData.polar,
        seam_id: productData.seam,
        procedure_id: productData.procedure_id,
        default_strand_id: defaultStrandID,
        procedure_is_assigned: hasOneProcedureAvailable,
        pattern_required: true,
        pattern_stays: false,
        pattern_before_order: false,
        procedure_start_date: null,
        processes: [],
        deleted: false
      });
    },
    removeProduct (productIndex) {
      this.data.products.splice(productIndex, 1);
    },
    setAllDataLoaded (newValue) {
      Vue.set(this, 'allDataLoaded', newValue);
    },
    setUpProducts (products) {
      this.data.products = JSON.parse(JSON.stringify(products));
    },
    setErrors (errors) {
      for (let i = 0; i < this.data.products.length; i++) {
        if (errors['order-product-' + i]) {
          this.$refs['order-product-' + i][0].setErrors(errors['order-product-' + i]);
        }
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('order-product-add', this.addProduct);
    this.$bus.$off('order-form-remove-product', this.removeProduct);
    this.$bus.$off('order-form-all-data-loaded-status', this.setAllDataLoaded);
  }
}
</script>

<style lang="scss" scoped>
.order-creator.is-loading {
  opacity: .25;
  pointer-events: none;
}
</style>
